import styled from 'styled-components';
import { body2, header6 } from '@westwing/ui-kit/typography';
import CloseButton from '@westwing/ui-kit/CloseButton';

export const ContentOverlay = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0s linear 0.51s;
    overflow-y: auto;
    z-index: 50;
`;

export const CloseIconContainer = styled.div`
    padding: 20px;
    position: absolute;
    right: 1px;
    top: 65px;
    display: flex;

    ${CloseButton} {
        &:focus {
            box-shadow: none;
        }
    }
`;

export const Sections = styled.div`
    background-color: inherit;
    padding-bottom: 60px;
`;

export const Section = styled.div``;

export const SectionTitle = styled.h4<{ $isMainSectionTitle: boolean }>`
    ${header6}
    color: ${({ theme }) => theme.colors.charcoal100};
    line-height: 25px;
    text-align: center;

    ${({ $isMainSectionTitle, theme }) =>
        $isMainSectionTitle
            ? `
                padding: 23px 0 20px;
                border-bottom: none;
            `
            : `
                font-size: 18px;
                padding: 25px 0 23px;
                border-bottom: 1px solid ${theme.colors.borderCharcoal};
            `}
`;

export const Clickable = styled.a`
    display: flex;
    flex-direction: row;
    height: 52px;
    align-items: center;
    padding: 0 25px;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

export const BorderedBox = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderCharcoal};
    height: 100%;
    display: flex;
    flex-grow: 1;
    align-items: center;
`;

export const Title = styled.div`
    ${body2}
`;

export const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
    margin-right: 9px;

    > div {
        display: flex;
    }
`;
